import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { IziviaToastService } from '../services/common/iziviaToast.service';

@Injectable({
    providedIn: 'root'
})
export class MulesoftApiInterceptor implements HttpInterceptor {

    constructor(private toastService: IziviaToastService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error?.labelKey === 'error.mulesoft.api') {
                    this.toastService.showError('error.mulesoft.api');
                }

                return throwError(() => error);
            })
        );
    }
}
